import React, {useContext, useEffect, useState} from "react";
import {Droppable} from "react-beautiful-dnd";
import {AppContext} from "../../../Utils/AppContext";
import "./style.scss";

export default function DragToNewRoute(props) {
    const appContext = useContext(AppContext);
    const [groupColor, setGroupColor] = useState("transparent");


    useEffect(() => {
        if (props.isDraggingOutside)
            setGroupColor(appContext.iconColors.getAvailableColor().primaryColor);
    }, [props.isDraggingOutside]);

    return (
        <Droppable droppableId="route-new">
            {(provided, snapshot) => (
                <div className="route-new"
                     style={{border: `6px solid ${groupColor}`}}
                     ref={provided.innerRef} {...provided.droppableProps}>
                    <div className="route-new-content">
                        <div className="route-new-place-holder">
                            {provided.placeholder}
                        </div>
                        <div>
                            שחרר כדי ליצור מסלול חדש
                        </div>
                        <div className="route-new-place-holder">
                            {provided.placeholder}
                        </div>
                    </div>
                </div>
            )}
        </Droppable>
    );
}